<template>
  <XField
    :errors="validationErrors(formattedLabel)"
    :errorStyle="formFieldsErrorStyle"
  >
    <VSelect
      :label="parameters.config.label"
      :labelStyle="labelStyle"
      eSelectLabel="name"
      trackBy="ticket"
      :searchable="false"
      v-model="fieldValue"
      v-validate="{ required: parameters.required }"
      :inputErrorStyle="inputCustomStyles"
      :options="ticketOptions"
      :maxHeight="maxMenuHeight"
      :openDirection="menuOpenDirection"
      :data-vv-name="formattedLabel"
      :invalid="validationHasErrors(formattedLabel)"
      :optional="isOptional"
      :disabled="isDisabled"
      @close="validate"
    >
      <template
        slot="singleLabel"
        slot-scope="{ option }"
      >
        <strong>{{ option.name }}</strong>
      </template>
    </VSelect>

    <div
      v-if="isFullCapacity"
      class="flex items-center rounded bg-warning-60 max-w-sm mx-auto text-white text-sm font-bold px-4 py-3 mb-8"
      role="alert"
    >
      <svg
        class="fill-current w-20 h-20 mr-4"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"><path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z"/></svg>
      <p>{{ fullCapacityMessage }}</p>
    </div>
  </XField>
</template>

<script>
import gql from 'graphql-tag'
import VSelect from '@plat/components/VueSelect'

import _ from 'lodash'

import InputMixin from './InputMixin'

export default {
  data () {
    return {
      isDisabled: false,
      isFullCapacity: false,
      ticketAsDefault: ''
    }
  },

  mixins: [InputMixin],

  components: { VSelect },

  props: {
    ticketTypes: {
      type: Array,
      required: true
    },
    eventId: {
      type: String,
      required: true
    }
  },

  created () {
    const urlParams = new URLSearchParams(window.location.search)
    this.ticketAsDefault = urlParams.has('t') ? urlParams.get('t') : ''

    this.isDisabled = false
    if (this.fieldValue === null) {
      this.fieldValue = ''
    }

    if (this.fieldValue !== '') {
      this.ticketTypes.map(field => {
        if (field.ticket === this.fieldValue) {
          this.fieldValue = {
            'name': field.label.replace('(lista de espera)', '').replace('(waiting list)', ''),
            'ticket': field.ticket,
            'price': field.price
          }
        }
      })

      this.isDisabled = true

      // if (this.ticketAsDefault !== '') {
      //   this.isDisabled = true
      // }
    }

    if (typeof this.fieldValue === 'object') {
      if (this.fieldValue.ticket === 'General') {
        this.isDisabled = false
      }
    } else {
      if (this.fieldValue === 'General') {
        this.isDisabled = false
      }
    }

    // console.log(this.ticketTypes)
    // console.log(this.ticketAsDefault)
    // console.log(this.ticketOptions)
  },

  computed: {
    formattedLabel () {
      return _.lowerCase(this.parameters.config.label)
    },

    maxMenuHeight () {
      return this.parameters.componentOptions
        ? this.parameters.componentOptions.maxHeight || 300
        : 300
    },

    ticketOptions () {
      let tickets = []
      let ticketAsDefault = this.ticketAsDefault

      this.ticketTypes.forEach(function (field) {
        if (ticketAsDefault !== '') {
          if (field.ticket.replace('#', '_').toLowerCase() === ticketAsDefault.toLowerCase()) {
            tickets.push({
              'name': field.label,
              'ticket': field.ticket,
              'price': field.price
            })
          }
        } else {
          tickets.push({
            'name': field.label,
            'ticket': field.ticket,
            'price': field.price
          })
        }
      })

      return tickets
    },

    menuOpenDirection () {
      return this.parameters.componentOptions
        ? this.parameters.componentOptions.openDirection || ''
        : ''
    },

    fullCapacityMessage () {
      return this.$t('common.notifications.messages.fullCapacity')
    }
  },

  methods: {
    async validate () {
      this.$validator.validate(this.formattedLabel)
      this.$emit('loadingTicketType', true)

      if (this.fieldValue) {
        this.$apollo
          .query({
            query: gql`query Event ($eventId: Uuid!, $ticketType: String) {
              event (eventId: $eventId) {
                isRegistrationFullCapacity (ticketType: $ticketType)
              }
            }`,
            fetchPolicy: 'network-only',
            variables: {
              eventId: this.eventId,
              ticketType: this.fieldValue.ticket
            }
          })
          .then(result => {
            this.isFullCapacity = result.data.event.isRegistrationFullCapacity
            this.$emit('ticketTypeFullCapacity', this.isFullCapacity)
            this.$emit('loadingTicketType', false)
          })
      }
    }
  }
}
</script>
